import type { EmpresaTenant } from './models';

/**
 * Empresas oferecidas no seletor de escopo das alçadas: só as vinculadas a um grupo econômico e ativas (as órfãs e
 * as sem grupo ficam de fora). `manter` são ids já gravados na alçada em edição: continuam visíveis para o valor atual
 * não sumir em silêncio, mesmo que a empresa tenha saído do grupo depois.
 */
export const empresasElegiveisParaEscopo = <T extends Pick<EmpresaTenant, 'id' | 'nome' | 'grupoId' | 'status'>>(
  empresas: T[], manter: number[] = [],
): T[] =>
  empresas
    .filter(e => manter.includes(e.id) || (e.grupoId != null && e.status === 'ATIVA'))
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));

export const empresaSemVinculoValido = (e: Pick<EmpresaTenant, 'grupoId' | 'status'>): boolean => e.grupoId == null || e.status !== 'ATIVA';
